export class JsonTranspositions {
  public libraries = {};
  public default_library: string;
}
